import React, { useState, useEffect } from 'react'

import * as StringFormatter from '../../../global/formatters/string-formatter.js'
import { removeSpecialCharacters } from '../../utility/strings/strings.js'

import { renderLiteratureLink } from './Helpers/Utilities.js'

import { getRiaData } from './Helpers/Helper.js'

import { Table } from '../index.js'

import { init } from '../../../global/authentication/secure-link-manager.js'

export const RiaLiterature = () => {
  const [mutualFunds, setMutualFunds] = useState()
  const [etfFunds, setEtfFunds] = useState()

  const getAspect = (section) => {
    const aspects = [
      {
        name: '#funds',
        info: {
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Fund Name',
              content: <div>Fund Name</div>,
              cell: {
                content: (fund) => (
                  <a
                    className="u-textBold"
                    href={`/investment-products/mutual-funds/${StringFormatter.urlSafe(
                      removeSpecialCharacters(fund.fundName)
                    )}/Class-${fund.fundClass}/details/?cusip=${fund.cusip}`}
                  >
                    {`${fund.fundName} (${fund.symbol})`}
                  </a>
                ),
              },
            },
            {
              name: 'reports',
              className: 'Table-header',
              ariaLabel: 'Reports',
              content: <div>Reports</div>,
              cell: {
                content: (fund) => (
                  <>
                    {fund.documents.length > 0
                      ? fund.documents
                          .filter(
                            (doc) => doc.label === 'Attribution/Contribution'
                          )
                          .map((document, idx) => {
                            return renderLiteratureLink(document, idx)
                          })
                      : null}
                  </>
                ),
              },
            },
            {
              name: 'factSheets',
              className: 'Table-header',
              ariaLabel: 'Fact Sheets',
              content: <div>Fact Sheets</div>,
              cell: {
                content: (fund) => (
                  <>
                    {fund.documents.length > 0
                      ? fund.documents
                          .filter((doc) => doc.label === 'Fact Sheet')
                          .map((document, idx) => {
                            return renderLiteratureLink(document, idx)
                          })
                      : null}
                  </>
                ),
              },
            },
            {
              name: 'commentaries',
              className: 'Table-header',
              ariaLabel: 'Commentaries',
              content: <div>Commentaries</div>,
              cell: {
                content: (fund) => (
                  <>
                    {fund.documents.length > 0
                      ? fund.documents
                          .filter((doc) =>
                            [
                              'Fund Commentary',
                              'Annual Fund Commentary',
                              'Monthly Fund Commentary',
                              'Quarterly Fund Commentary',
                            ].includes(doc.label)
                          )
                          .map((document, idx) => {
                            return (
                              <div key={idx}>
                                {renderLiteratureLink(document, idx)}
                              </div>
                            )
                          })
                      : null}
                  </>
                ),
              },
            },
          ],
        },
      },
      {
        name: '#etfFunds',
        info: {
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Fund Name',
              content: <div>Fund Name</div>,
              cell: {
                content: (fund) => (
                  <a
                    className="u-textBold"
                    href={`/investment-products/exchange-traded-funds/${StringFormatter.urlSafe(
                      removeSpecialCharacters(fund.fundName)
                    )}/Class-ETF/details/?cusip=${fund.cusip}`}
                  >
                    {`${fund.fundName.replace(' ETF', '')} (${
                      fund.symbol
                    }) ETF`}
                  </a>
                ),
              },
            },
            {
              name: 'factSheets',
              className: 'Table-header',
              ariaLabel: 'Fact Sheets',
              content: <div>Fact Sheets</div>,
              cell: {
                content: (fund) => (
                  <>
                    {fund.documents.length > 0
                      ? fund.documents
                          .filter((doc) => doc.label === 'Fact Sheet')
                          .map((document, idx) => {
                            return renderLiteratureLink(document, idx)
                          })
                      : null}
                  </>
                ),
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === section).info
  }

  useEffect(() => {
    initializeFunds()
  }, [])

  useEffect(() => {
    // updateSecureLinks()
    init()
  }, [])

  const initializeFunds = async () => {
    const mutualFundData = await getRiaData('mutual-funds')
    const etfFundData = await getRiaData('exchange-traded-funds')
    setMutualFunds(mutualFundData)
    setEtfFunds(etfFundData)
  }

  const mutualAspect = getAspect('#funds')
  const etfAspect = getAspect('#etfFunds')

  return (
    <div className="investment-products u-bgColorLight">
      <div className="u-sizeConstrained u-paddingTop4gu u-paddingBottom4gu">
        <div className="u-marginTop4gu u-marginBottom4gu">
          <h2>Ria Focus Funds</h2>
          <p className="u-marginBottom4gu">
            No transaction fees for Columbia Threadneedle mutual funds
            (Institutional 2 Share Class) and ETFs at Fidelity, Schwab and
            Pershing.
          </p>
          <h3 className="u-marginBottom4gu">Mutual Funds</h3>
          <Table
            columns={mutualAspect.columns}
            rows={mutualFunds}
            mode="no-stripe"
          />
          <h3 className="u-marginTop10gu u-marginBottom4gu">
            Exchange Traded Funds (ETFs)
          </h3>
          <Table columns={etfAspect.columns} rows={etfFunds} mode="no-stripe" />
        </div>
      </div>
    </div>
  )
}
